<template functional>
  <a-entity id="vr-environment">
    <a-entity>
      <a-camera stereocam="eye:left;"></a-camera>

      <a-entity
        id="leftHand"
        hand-controls="hand: left; handModelStyle: lowPoly; color: #ffcccc"
      ></a-entity>
      <a-entity
        id="rightHand"
        hand-controls="hand: right; handModelStyle: lowPoly; color: #ffcccc"
      ></a-entity>

      <a-entity
        light="type: hemisphere; color: #d6d37c; groundColor: #FFFAAA; intensity: 0.3;"
      ></a-entity>
      <a-entity
        light="type: spot; color: #FFF; intensity: 1; penumbra: .2; target: #vr-environment-floor"
        position="-1 5 0; castShadow: true"
      ></a-entity>
    </a-entity>

    <a-sky color="#222"></a-sky>

    <a-box
      id="vr-environment-wall"
      width="20"
      height="10"
      depth=".25"
      position="0 4 -2.25"
      roughness=".8"
      :src="props.wall"
      repeat="20 10"
    ></a-box>

    <a-box
      id="vr-environment-trim"
      width="20"
      height=".4"
      depth=".05"
      position="0 -1 -2.125"
      roughness=".8"
      :src="props.trim"
      repeat="30 1"
    ></a-box>

    <a-circle
      id="vr-environment-floor"
      color="#CCC"
      radius="10"
      position="0 -1 0"
      segments="64"
      rotation="-90 0 0"
      :src="props.floor"
      repeat="8 8"
    ></a-circle>
  </a-entity>
</template>

<script>
export default {
  name: "VrEnvironment",

  props: {
    trim: {
      required: true,
      type: String,
    },
    wall: {
      required: true,
      type: String,
    },
    floor: {
      required: true,
      type: String,
    },
  },
};
</script>
